// TODO: make more specific error classes like ConflictError
class ResponseError extends Error {
  response: Response;

  constructor(response: Response) {
    super();
    this.message = `Request failed with status code ${response.status}`;
    this.response = response;
  }
}

export default ResponseError;
